import { Loader } from '@mantine/core';

const SuspenseLoader = () => {
    return (
        <div className="py-80 flex justify-center items-center">
            <Loader />
        </div>
    );
};

export default SuspenseLoader;
